function chevronSlider() {
    const chevronSlider = document.getElementById('chevron-slider');
    const windowWidth = window.innerWidth;

    if(!chevronSlider) {
        return;
    }

    if(windowWidth > 768){
        var slideTrack = document.getElementById('slide-track');
        var widthInfo = slideTrack.getBoundingClientRect();
        var width = widthInfo.width;
        var slideAmount = windowWidth - width - 100;
        var Slides = document.querySelectorAll('[data-slides]');
        var activeBullet = chevronSlider.querySelector('[data-slide-bullet="active"]');
        var inactiveBullet = chevronSlider.querySelector('[data-slide-bullet="inactive"]');
        Slides.forEach(function(e) {
            e.addEventListener("click", event => {
                if(chevronSlider.classList.contains("active")){
                    chevronSlider.classList.remove("active");
                } else {
                    chevronSlider.classList.add("active");
                }
            });
        });

        activeBullet?.addEventListener("click", event => {
            chevronSlider.classList.add("active");
        });
        inactiveBullet?.addEventListener("click", event => {
            chevronSlider.classList.remove("active");
        });
    } else{
            let options = {
                threshold: 0.6,
                rootMargin: "0px 0px 0px -10px"
            }

            let bullets = document.querySelectorAll('.mobile-dots .bullets');
            let slides = chevronSlider.querySelectorAll('[data-slide]');
            bullets.forEach((bullet, index) => {
                bullet.addEventListener('click', () => {
                    let slideOffset = slides[index]?.offsetLeft || 0;
                    chevronSlider.scroll(slideOffset, 0);
                });
            });
            
            let setInview = (entries, observer) => {
                entries.forEach(entry => {
                    let slideNum = entry.target.dataset.slide;
                    let bullet = document.querySelector(`[data-bullets="${slideNum}"]`);
                    if (entry.isIntersecting) {
                        bullet.classList.add('in-view');
                    }
                    else {
                        bullet.classList.remove('in-view');
                      }
                });
            }
            
            let observer = new IntersectionObserver(setInview, options);
            let targets = document.querySelectorAll('[data-slides]');
            
            targets.forEach(target => {
                observer.observe(target);
            });

    }
    
    document.documentElement.style.setProperty(`--slideAmount`, `${slideAmount}px`);
}

export default chevronSlider;